import React from 'react'
import { IoMdClose } from 'react-icons/io'
import './ViewBranchesModal.css';
import { toast } from 'react-toastify';
import axios from 'axios';

const ViewBranchesModal = ({ closeModal, selectedOfficer }) => {

    const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
    const authToken = tokens?.token || null;

    const handleRemoveBranchAssociation = async (branch) => {
        if (!authToken) {
            toast.error('Missing or invalid authentication token.');
            return;
        }

        const headers = {
            'Authorization': `Bearer ${authToken}`,
            'Content-type': 'application/json',
        }

        let associationObj = {
            officer_id: selectedOfficer?.officerId,
            secondary_branch_code: branch?.branch_code
        }

        // console.log({associationObj});

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/officer/remove-secondary-branch`, associationObj, { headers });

            if (response.data.status) {
                console.log('Branch removed successfully:', response.data);
                toast.success(`${response?.data?.message}`);

                closeModal();
            } else {
                toast.error(response.data.message || 'Failed to remove branch');
            }
        } catch (err) {
            let errorMsg = err?.response?.data?.message;
            toast.error(`${errorMsg}`);
        }
    }

    return (
        <div>
            <div className="modal-overlay" onClick={closeModal}></div>

            <div className="add-user-modal">
                <div className="modal-header">
                    <h5>All Secondary Branches</h5>
                    <button className="close-btn" onClick={closeModal}>
                        <IoMdClose />
                    </button>
                </div>

                <p className="modal-subtitle">
                    List of all other branches for the officer {selectedOfficer?.name} ({selectedOfficer?.employeeId})
                </p>

                <div className="branch-list">
                    {
                        selectedOfficer?.secondaryBranches?.length === 0 ? (
                            <div className="">
                                No secondary branches found
                            </div>
                        ) : (
                            selectedOfficer?.secondaryBranches?.map((branch) => {
                                return (
                                    <div className="branch-item">
                                        <span className="branch-item-text">{`${branch?.branch_name} (${branch?.branch_code})`}</span>
                                        <button
                                            onClick={() => {
                                                handleRemoveBranchAssociation(branch)
                                            }}
                                            className="ghost-btn"
                                        >
                                            <IoMdClose />
                                        </button>
                                    </div>
                                )
                            })
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default ViewBranchesModal